// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2usg6","actionsCol":"EnrolledClinics_actionsCol__1BcsF"};